import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	display: flex;
	align-items: center;
	width: 100%;
`;

export const LeftWrapper = styled.div`
	display: flex;
	align-items: center;
`;

export const DropdownWrapper = styled.div`
	button:first-child {
		border-bottom: 1px solid ${colors.grey4};
	}
`;

export const RightWrapper = styled.div`
	margin-left: auto;
	display: flex;
	align-items: center;
`;

export const Divider = styled.div`
	width: 1px;
	height: 24px;
	margin: 0 10px 0 16px;
	background-color: ${colors.grey3};
`;

export const Label = styled.div`
	font-weight: 400;
	font-size: 13px;
	line-height: 16px;
	color: ${colors.grey5};
	padding-left: 16px;
	padding-right: 4px;

	&:first-child {
		padding-left: 0;
	}
`;

export const CheckboxWrapper = styled.div`
	padding-left: 14px;
`;

export const DownloadDeckBtn = styled.button`
	max-width: 100%;
	height: 38px;
	border: none;
	font-weight: 500;
	font-size: 13px;
	-webkit-letter-spacing: 0.3px;
	-moz-letter-spacing: 0.3px;
	-ms-letter-spacing: 0.3px;
	letter-spacing: 0.3px;
	text-transform: uppercase;
	color: #1a1a1a;
	border: 1px solid transparent;
	display: -webkit-box;
	display: -webkit-flex;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: justify;
	-webkit-justify-content: space-between;
	-ms-flex-pack: justify;
	justify-content: space-between;
	-webkit-align-items: center;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	padding: 4px 0 4px 2px;
	background-color: #ffffff;
	outline: none;
	cursor: pointer;
`;